module.exports = __webpack_public_path__ + "img/FallaEnEnergia.8148626c.svg";